import reactFlowService from './reactFlowService';

export const excalidrawService = {
  /**
   * Récupère les données Excalidraw pour un cadrage
   * @param cadrageId - L'ID du cadrage
   */
  async getCadrageData(cadrageId: string): Promise<any> {
    return reactFlowService.getCadrageFlow(cadrageId);
  },

  /**
   * Sauvegarde les données Excalidraw pour un cadrage
   * @param cadrageId - L'ID du cadrage
   * @param payload - Les données Excalidraw à sauvegarder
   */
  async saveCadrageData(cadrageId: string, payload: any): Promise<any> {
    return reactFlowService.saveCadrageFlow(cadrageId, payload);
  },

  /**
   * Récupère les données Excalidraw pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   */
  async getUseCaseData(useCaseId: string): Promise<any> {
    return reactFlowService.getUseCaseFlow(useCaseId);
  },

  /**
   * Sauvegarde les données Excalidraw pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   * @param payload - Les données Excalidraw à sauvegarder
   */
  async saveUseCaseData(useCaseId: string, payload: any): Promise<any> {
    return reactFlowService.saveUseCaseFlow(useCaseId, payload);
  }
};

export default excalidrawService;
